// src/Footer.js

import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css'; // Import your CSS file for additional styling
import { Youtube } from "lucide-react"
import { YouTube, Facebook, Instagram } from '@mui/icons-material';

const Footer = () => {
  const navigate = useNavigate();

  const location = useLocation(); // Detects route change

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on route change
  }, [location.pathname]);

  return (
    <footer className="footer mt-5">
      <div className="subscription-bar py-3">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4 text-center text-md-left mb-2 mb-md-0">
              <img src="/tel.svg" className="icon" alt="subscribe" />
              <span className="subscribe-text">Subscribe here for</span>
            </div>
            <div className="col-md-4 text-center text-md-left mb-2 mb-md-0">
              <span className="new-products">... New products and deals</span>
            </div>
            <div className="col-md-4 text-center text-md-right">
              <div className="input-group">
                <input type="email" className="form-control" placeholder="Enter your Email" />
                <div className="input-group-append">
                  <button className="btn btn-dark" type="button">
                    <span>Sign up </span>
                    <img src="./bell.png" alt="sign up" className="ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <div className="row text-center text-md-left">
          <div className="col-md-4 mb-4">
            <h1>KHOSLA <span className="electronic">ELECTRONICS</span></h1>
            <div className="social-icons">
              {/* <Link to="#"><img src="/facebook.png" alt="Facebook" /></Link>
              <Link to="#"><img src="/insta.png" alt="Instagram" /></Link> */}
              <Facebook sx={{fontSize: '3vw', marginRight: '10px'}}/>
              <Instagram sx={{  fontSize: '3vw', marginRight: '10px'}}/>
              <YouTube sx={{ fontSize: '3vw'}} onClick={() => window.location.href = "https://www.youtube.com/@khoslaelectronicsyoutube"}/>
            </div>
          </div>
          <div className="col-md-2 mb-4">
            <h6 className="font-weight-bold">Find It Fast</h6>
            <ul className="list-unstyled">
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/career">Career</Link></li>
              <li><Link to="/store-locator">Store Locator</Link></li>
            </ul>
          </div>
          <div className="col-md-3 mb-4">
            <h6 className="font-weight-bold">Terms & Conditions</h6>
            <ul className="list-unstyled">
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/shipping-options">Shipping Options</Link></li>
              <li><Link to="/payment-return-policies">Payment & Return Policies</Link></li>
            </ul>
          </div>
          <div className="col-md-3 mb-4">
            <h6 className="font-weight-bold">Customer Care</h6>
            <ul className="list-unstyled">
              <li><Link to="/cart">Cart</Link></li>
              <li><Link to="/checkout">Checkout</Link></li>
              <li><Link to="/my-account">My Account</Link></li>
              <li><Link to="/wishlist">Wishlist</Link></li>
            </ul>
          </div>
        </div>
        <div className="row text-center payment-icons mb-4">
          <div className="col footer-img-container">
            <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/image/mastercard.png" alt="Mastercard" />
            <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/image/visa.png" alt="Visa" />
            <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/image/amex.png" alt="American Express" />
            <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/image/upi.jpeg" alt="UPI" />
            <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/image/rupay.jpeg" alt="Rupay" />
            <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/image/netbanking.png" alt="Net Banking" />
          </div>
        </div>
        <div className="row text-center contact-info">
          <div className="col-md-4 mb-4 w-full pl-10 pr-10">
            <a href='https://www.google.com/maps/place/15,+2B,+Dhirendranath+Ghosh+Rd,+Bhowanipore,+Kolkata,+West+Bengal+700025/@22.5336001,88.3410126,17z/data=!3m1!4b1!4m5!3m4!1s0x3a0277472a3fe82d:0xe4f565f02bc5fd7e!8m2!3d22.5336001!4d88.3410126?sa=X&ved=2ahUKEwiArun31oj-AhWvg2MGHSl9DLQQ8gF6BAgVEAI&coh=164777&entry=tt&shorturl=1' target='_blank'>
              <div className="contact-box">
                <img src="/a.png" alt="Address" />
                <p>15/2B Dhirendra Nath Ghose Road, Kolkata 700025</p>
              </div>
            </a>

          </div>
          <div className="col-md-4 mb-4 pl-10 pr-10">
            <a href='mailto:khoslaonline@khoslaelectronics.com' target='_blank'>
              <div className="contact-box">
                <img src="/email.png" alt="Email" />
                <p>khoslaonline@khoslaelectronics.com</p>
              </div>
            </a>

          </div>
          <div className="col-md-4 mb-4">
            <a href='tel:+91 9511943020' target='_blank'>
              <div className="contact-box">
                <img src="/audio.png" alt="Phone" />
                <p>+91 9511943020</p>
              </div>
            </a>

          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>Copyright © 2024 Khosla Electronics | Powered by Khosla Electronics</p>
          </div>
        </div>
      </div>
      <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
        'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
        '_blank'
      )} />
    </footer>
  );
};

export default Footer;
